export enum OrdersDataErrorCodes {
  DATE_FROM_AFTER_DATE_TO = 'date_from_after_date_to',
}

export const OrderDataErrorMessages: Record<OrdersDataErrorCodes, string> = {
  [OrdersDataErrorCodes.DATE_FROM_AFTER_DATE_TO]:
    '開始日が終了日よりも後の日付です',
};
